module.exports = __webpack_public_path__ + "static/img/yiLun.75d15e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LunBo/yiLun.jpg
// module id = Yh+7
// module chunks = 0